/**
 * Social proof for the Provider page.
 *
 * Only add real, approved content here. Each list drives its own section on
 * the page, and a section stays hidden while its list is empty.
 */

export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  organization?: string;
  /** Imported image URL, e.g. `import photo from "../assets/..."`. */
  avatar?: string;
}

export interface EvidenceStat {
  /** Headline figure, e.g. "42%". */
  value: string;
  label: string;
  /** Where the number comes from (study, pilot, date). Shown under the label. */
  source?: string;
}

export interface Partner {
  name: string;
  /** Imported logo URL. Falls back to the name as text when omitted. */
  logo?: string;
  href?: string;
}

export interface TrustBadge {
  /** Only list certifications and attestations that are currently held. */
  label: string;
  detail?: string;
  href?: string;
}

export const testimonials: Testimonial[] = [];
export const evidenceStats: EvidenceStat[] = [];
export const partners: Partner[] = [];
export const trustBadges: TrustBadge[] = [];
